import React from "react";
import classNames from "classnames";

const VehicleTypeSwitcherLink = ({
  currentState,
  targetState,
  switchVehicleState,
}) => {
  return (
    <span
      className={classNames(" pt-1 fs-14p fw-bold", {
        "text-primary": currentState === targetState,
        "text-black-50 cursor-pointer": currentState !== targetState,
      })}
      onClick={() => {
        if (currentState !== targetState) switchVehicleState();
      }}
    >
      {`${targetState} Cars`.toUpperCase()}
    </span>
  );
};

export default VehicleTypeSwitcherLink;
